import { formatZAR, type BookingPricing } from '@makhe/shared';

// Buyers only ever see the total — commission is between Makhe and the
// seller. Pass showPayout on seller-facing views so they still see what
// lands in their pocket.
export function PriceBreakdown({
  pricing,
  showPayout = false,
}: {
  pricing: BookingPricing;
  showPayout?: boolean;
}) {
  return (
    <dl className="rounded-2xl bg-makhe-paper p-4 text-sm">
      <Row label="Service" value={pricing.baseZARcents} />
      {pricing.afterHoursSurchargeZARcents > 0 && (
        <Row label="After-hours surcharge" value={pricing.afterHoursSurchargeZARcents} />
      )}
      {pricing.promoDiscountZARcents && pricing.promoDiscountZARcents > 0 && (
        <Row label={`Promo (${pricing.promoCodeApplied ?? 'discount'})`} value={-pricing.promoDiscountZARcents} />
      )}
      <Row label="Total" value={pricing.totalZARcents} bold />
      {showPayout && (
        <p className="mt-2 text-xs text-makhe-muted/80">
          You receive {formatZAR(pricing.sellerPayoutZARcents)} on completion (after the{' '}
          {formatZAR(pricing.commissionZARcents)} Makhe fee).
        </p>
      )}
    </dl>
  );
}

function Row({ label, value, bold }: { label: string; value: number; bold?: boolean }) {
  return (
    <div className={`flex items-center justify-between py-1 ${bold ? 'text-base font-semibold' : ''}`}>
      <dt>{label}</dt>
      <dd>{formatZAR(value)}</dd>
    </div>
  );
}
